
	import { createChat } from 'https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js';

	createChat({
		webhookUrl: 'https://liec-n8n-n8n.wxeifq.easypanel.host/webhook/e3f1ccb3-ad05-43f7-9363-574b4b9722a0/chat',
        initialMessages: [
		'Hola! 👋',
		'Soy LIEC Assitant, ¿En que puedo ayudarte hoy?'
	],
	i18n: {
		en: {
			title: 'Bienvenido 👋',
			subtitle: "Inicia un chat en el momento que quieras 24/7.",
			footer: '',
			getStarted: 'Nueva conversación',
			inputPlaceholder: 'Escribe tu pregunta...',
		},
	},
	});
